import { render, staticRenderFns } from "./RelatPedidosInsVet.vue?vue&type=template&id=22a0a33a&"
import script from "./RelatPedidosInsVet.vue?vue&type=script&lang=js&"
export * from "./RelatPedidosInsVet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports